export * from "./src/atenea.module";
export * from "./src/core";
export * from "./src/crud-box";
export * from "./src/notify";
export { MaterialModule } from "./src/material/material.module";



// WEBPACK FOOTER //
// ./libs/atenea-cms/index.ts